import { Section, defineComponent } from '@decify/cell-shopify/client';
export const productContextName = 'ProductContext';
export const productContextTagName = 'cell-component-product-context';
export class ProductContext extends Section {
    // TODO: Fix this type error.
    // @ts-ignore
    product;
    constructor() {
        super(productContextName);
    }
    componentDidMount() {
        const scriptElement = this.children[0];
        if (!(scriptElement instanceof HTMLScriptElement)) {
            throw new Error('Expected a script element as first child');
        }
        // TODO: Validate the product object.
        // TODO: Fix this type error.
        // @ts-ignore
        const product = JSON.parse(scriptElement.textContent);
        this.product = product;
    }
}
defineComponent(productContextTagName, ProductContext);
